import {
  AlignmentType,
  BorderStyle,
  convertInchesToTwip,
  Document,
  HeadingLevel,
  ImageRun,
  LevelFormat,
  OverlapType,
  Packer,
  Paragraph,
  RelativeHorizontalPosition,
  RelativeVerticalPosition,
  Table,
  TableAnchorType,
  TableCell,
  TableRow,
  TextRun,
  VerticalAlign,
  WidthType,
} from "docx";
import { saveAs } from "file-saver";

function GetEmptyRows(contacts = ''){
  let pars = []
  for (let i = 0; i < 12 - contacts.split('\n').length; i++){
    pars.push(new Paragraph(""))
  }
  return pars
}
function GetContactsRows(contacts = '') {
  let pars = []
  contacts = contacts.split('\n')
  for (let i = 0; i < contacts.length; i++){
    pars.push(new Paragraph(contacts[i]))
  }
  return pars
}

function GetDate(date) {
  let mounth = "";
  switch (date.slice(3, 5)) {
    case "01":
      mounth = "Января";
      return `«${date.slice(0, 2)}»  ${mounth}   ${date.slice(6, 10)}   года`;
    case "02":
      mounth = "Февраля";
      return `«${date.slice(0, 2)}»  ${mounth}   ${date.slice(6, 10)}   года`;
    case "03":
      mounth = "Марта";
      return `«${date.slice(0, 2)}»  ${mounth}   ${date.slice(6, 10)}   года`;
    case "04":
      mounth = "Апреля";
      return `«${date.slice(0, 2)}»  ${mounth}   ${date.slice(6, 10)}   года`;
    case "05":
      mounth = "Мая";
      return `«${date.slice(0, 2)}»  ${mounth}   ${date.slice(6, 10)}   года`;
    case "06":
      mounth = "Июня";
      return `«${date.slice(0, 2)}»  ${mounth}   ${date.slice(6, 10)}   года`;
    case "07":
      mounth = "Июля";
      return `«${date.slice(0, 2)}»  ${mounth}   ${date.slice(6, 10)}   года`;
    case "08":
      mounth = "Августа";
      return `«${date.slice(0, 2)}»  ${mounth}   ${date.slice(6, 10)}   года`;
    case "09":
      mounth = "Сентября";
      return `«${date.slice(0, 2)}»  ${mounth}   ${date.slice(6, 10)}   года`;
    case "10":
      mounth = "Октября";
      return `«${date.slice(0, 2)}»  ${mounth}   ${date.slice(6, 10)}   года`;
    case "11":
      mounth = "Ноября";
      return `«${date.slice(0, 2)}»  ${mounth}   ${date.slice(6, 10)}   года`;
    case "12":
      mounth = "Декабря";
      return `«${date.slice(0, 2)}»  ${mounth}   ${date.slice(6, 10)}   года`;
    default:
      break;
  }
}

function GetClientName(form) {
  if (form.thirdPersonPayment){
    return [
      new Paragraph({
        style: "myWonkyStyle",
        text: "Покупатель: " + form.thirdPersonDetails,
      }),
    ];
  }
  if (form.clientType.type === "ю.л.") {
    return [
      new Paragraph({
        style: "myWonkyStyle",
        text: "Покупатель: "+(form.clientType.ofp === 'Иное' ? form.clientType.shortofp : form.clientType.ofp)+" «" + form.clientType.shortname + "»",
      }),
      new Paragraph({
        style: "myWonkyStyle",
        text: "ИНН " + form.clientType.inn,
      }),
      new Paragraph({
        style: "myWonkyStyle",
        text: "ОГРН " + form.clientType.ogrn,
      }),
    ];
  }
  return [
    new Paragraph({
      style: "myWonkyStyle",
      text: "Покупатель: " + form.clientType.fio,
    }),
    new Paragraph({
      style: "myWonkyStyle",
      text: "Прочие данные: " + form.clientType.otherDetails,
    }),
  ];
}

function GetReqAct(form) {
  if (form.clientType.type === "ю.л.") {
    if (form.clientType.ofp === "ИП") {
      return new TableCell({
                borders: {
          top: {
            style: BorderStyle.NONE,
            size: 0,
            color: "FFFFFF",
          },
          bottom: {
            style: BorderStyle.NONE,
            size: 0,
            color: "FFFFFF",
          },
          left: {
            style: BorderStyle.NONE,
            size: 0,
            color: "FFFFFF",
          },
          right: {
            style: BorderStyle.NONE,
            size: 0,
            color: "FFFFFF",
          },
        },
        width: {
          size: 5000,
          type: WidthType.DXA,
        },
        children: [
          new Paragraph(
              {children: [
                  new TextRun({
                    text:(form.clientType.ofp === 'Иное' ? form.clientType.shortofp : form.clientType.ofp)+" " + form.clientType.shortname,
                    size:24
                  }),
                ],}

          ),
          new Paragraph(
              {children: [
                  new TextRun({
                    text:"ИНН " + form.clientType.inn,
                    size:24
                  }),
                ],}),
          new Paragraph(
              {children: [
                  new TextRun({
                    text:"ОГРНИП " + form.clientType.ogrn,
                    size:24
                  }),
                ],}),
          new Paragraph(""),
          new Paragraph(""),
          new Paragraph(""),
          new Paragraph(""),
          new Paragraph(""),
          new Paragraph(""),
          new Paragraph(""),
          new Paragraph(""),
          new Paragraph(""),
          new Paragraph(""),
          new Paragraph(""),
          new Paragraph(""),
          new Paragraph(""),
          new Paragraph(""),
          new Paragraph(
              {children: [
                  new TextRun({
                    text:"Индивидуальный предприниматель",
                    size:24
                  }),
                ],}),
          // new Paragraph(form.clientType.doljnost),
          new Paragraph(""),
          // new Paragraph("______________ /" + form.clientType.family + "/"),
          new Paragraph(
              {children: [
                  new TextRun({
                    text:"______________ /" + form.clientType.family + "/",
                    size:24
                  }),
                ],}),
        ],
      });
    }
    return new TableCell({
            borders: {
        top: {
          style: BorderStyle.NONE,
          size: 0,
          color: "FFFFFF",
        },
        bottom: {
          style: BorderStyle.NONE,
          size: 0,
          color: "FFFFFF",
        },
        left: {
          style: BorderStyle.NONE,
          size: 0,
          color: "FFFFFF",
        },
        right: {
          style: BorderStyle.NONE,
          size: 0,
          color: "FFFFFF",
        },
      },
      width: {
        size: 5000,
        type: WidthType.DXA,
      },
      children: [
        new Paragraph(
          {children: [
            new TextRun({
              text:(form.clientType.ofp === 'Иное' ? form.clientType.shortofp : form.clientType.ofp)+" «" + form.clientType.shortname + "»",
              size:24
            }),
          ],}
          
        ),
        new Paragraph(
          {children: [
            new TextRun({
              text:"ИНН " + form.clientType.inn,
              size:24
            }),
          ],}),
        new Paragraph(
          {children: [
          new TextRun({
            text:"ОГРН " + form.clientType.ogrn,
            size:24
          }),
        ],}),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(
          {children: [
          new TextRun({
            text:"Генеральный директор",
            size:24
          }),
        ],}),
        // new Paragraph(form.clientType.doljnost),
        new Paragraph(""),
        // new Paragraph("______________ /" + form.clientType.family + "/"),
        new Paragraph(
          {children: [
          new TextRun({
            text:"______________ /" + form.clientType.family + "/",
            size:24
          }),
        ],}),
      ],
    });
  }
  if (form.clientType.type === "ф.л.") {
    return new TableCell({
            borders: {
        top: {
          style: BorderStyle.NONE,
          size: 0,
          color: "FFFFFF",
        },
        bottom: {
          style: BorderStyle.NONE,
          size: 0,
          color: "FFFFFF",
        },
        left: {
          style: BorderStyle.NONE,
          size: 0,
          color: "FFFFFF",
        },
        right: {
          style: BorderStyle.NONE,
          size: 0,
          color: "FFFFFF",
        },
      },
      width: {
        size: 5000,
        type: WidthType.DXA,
      },
      children: [
        new Paragraph(
          {children: [
            new TextRun({
              text:form.clientType.fio,
              size:24
            }),
          ],}),
        new Paragraph(""),
        new Paragraph(
          {children: [
            new TextRun({
              text:form.clientType.otherDetails,
              size:24
            }),
          ],}),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(
          {children: [
          new TextRun({
            text:"______________ /" + GetInitialsFromFIO(form.clientType.fio) + "/",
            size:24
          }),
        ],}),
      ],
    });
  }
}

function GetInitialsFromFIO(fio = '') {
  const parts = fio.split(" ")
  if (parts.length === 3) {
    return parts[0] + " " + parts[1].substring(0, 1) + ". " + parts[2].substring(0, 1) + "."
  }
  return fio;
}

function GetReq(form) {
  if (form.clientType.type === "ю.л.") {
    if (form.clientType.ofp === "ИП") {
      return new TableCell({
                borders: {
          top: {
            style: BorderStyle.NONE,
            size: 0,
            color: "FFFFFF",
          },
          bottom: {
            style: BorderStyle.NONE,
            size: 0,
            color: "FFFFFF",
          },
          left: {
            style: BorderStyle.NONE,
            size: 0,
            color: "FFFFFF",
          },
          right: {
            style: BorderStyle.NONE,
            size: 0,
            color: "FFFFFF",
          },
        },
        width: {
          size: 5000,
          type: WidthType.DXA,
        },
        children: [
          new Paragraph(
              // GetOfp(
              //   form.clientType.ofp,
              //   form.clientType.fullofp,
              //   form.clientType.shortofp
              // ) +
              //   " «" +
              //   form.clientType.name +
              //   "»"
              (form.clientType.ofp === 'Иное' ? form.clientType.shortofp : form.clientType.ofp)+" " + form.clientType.shortname
          ),
          new Paragraph("ИНН " + form.clientType.inn),
          new Paragraph("ОГРНИП " + form.clientType.ogrn),
          ...GetContactsRows(form.contacts),
            ...GetEmptyRows(form.contacts),
          new Paragraph(
              {children: [
                  new TextRun({
                    text:"Индивидуальный предприниматель",
                    size:22
                  }),
                ],}),
          // new Paragraph(form.clientType.doljnost),
          new Paragraph(""),
          // new Paragraph("______________ /" + form.clientType.family + "/"),
          new Paragraph(
              {children: [
                  new TextRun({
                    text:"______________ /" + form.clientType.family + "/",
                    size:22
                  }),
                ],}),
        ],
      });
    }
    return new TableCell({
            borders: {
        top: {
          style: BorderStyle.NONE,
          size: 0,
          color: "FFFFFF",
        },
        bottom: {
          style: BorderStyle.NONE,
          size: 0,
          color: "FFFFFF",
        },
        left: {
          style: BorderStyle.NONE,
          size: 0,
          color: "FFFFFF",
        },
        right: {
          style: BorderStyle.NONE,
          size: 0,
          color: "FFFFFF",
        },
      },
      width: {
        size: 5000,
        type: WidthType.DXA,
      },
      children: [
        new Paragraph(
          // GetOfp(
          //   form.clientType.ofp,
          //   form.clientType.fullofp,
          //   form.clientType.shortofp
          // ) +
          //   " «" +
          //   form.clientType.name +
          //   "»"
          (form.clientType.ofp === 'Иное' ? form.clientType.shortofp : form.clientType.ofp)+" «" + form.clientType.shortname + "»"
        ),
        new Paragraph("ИНН " + form.clientType.inn),
        new Paragraph("ОГРН " + form.clientType.ogrn),
        ...GetContactsRows(form.contacts),
        ...GetEmptyRows(form.contacts),
        new Paragraph(
          {children: [
          new TextRun({
            text:"Генеральный директор",
            size:22
          }),
        ],}),
        // new Paragraph(form.clientType.doljnost),
        new Paragraph(""),
        // new Paragraph("______________ /" + form.clientType.family + "/"),
        new Paragraph(
          {children: [
          new TextRun({
            text:"______________ /" + form.clientType.family + "/",
            size:22
          }),
        ],}),
      ],
    });
  }
  if (form.clientType.type === "ф.л.") {
    return new TableCell({
            borders: {
        top: {
          style: BorderStyle.NONE,
          size: 0,
          color: "FFFFFF",
        },
        bottom: {
          style: BorderStyle.NONE,
          size: 0,
          color: "FFFFFF",
        },
        left: {
          style: BorderStyle.NONE,
          size: 0,
          color: "FFFFFF",
        },
        right: {
          style: BorderStyle.NONE,
          size: 0,
          color: "FFFFFF",
        },
      },
      width: {
        size: 5000,
        type: WidthType.DXA,
      },
      children: [
        new Paragraph(form.clientType.fio),
        new Paragraph(""),
        new Paragraph(form.clientType.otherDetails),
        ...GetContactsRows(form.contacts),
        new Paragraph("______________ /" + GetInitialsFromFIO(form.clientType.fio) + "/"),
      ],
    });
  }
}

function GetStartTextAct(form) {
  if (form.clientType.type === "ю.л.") {
    if (form.clientType.ofp === "ИП") {
      return (
          "Общество с ограниченной ответственностью «ЮрБюро 88», в лице генерального директора Дяченко Софии Александровны, действующего на основании Устава, именуемое в дальнейшем «Исполнитель» с одной стороны и " +
          (GetOfp(
              form.clientType.ofp,
              form.clientType.fullofp,
              form.clientType.shortofp
          ))+" " + form.clientType.name +
          `, ОГРНИП ${form.clientType.ogrn}, именуемый в дальнейшем, «Заказчик», совместно именуемые «Стороны», подписали настоящий акт о нижеследующем:`
      );
    }
    return (
      "Общество с ограниченной ответственностью «ЮрБюро 88», в лице генерального директора Дяченко Софии Александровны, действующего на основании Устава, именуемое в дальнейшем «Исполнитель» с одной стороны и " +
      (GetOfp(
        form.clientType.ofp,
        form.clientType.fullofp,
        form.clientType.shortofp
      ))+" «" + form.clientType.name +
      "» в лице Генерального директора " +
      form.clientType.inface +
      ", действующего на основании Устава, именуемое в дальнейшем, «Заказчик», совместно именуемые «Стороны», подписали настоящий акт о нижеследующем:"
    );
  }
  if (form.clientType.type === "ф.л.") {
    return (
      "Общество с ограниченной ответственностью «ЮрБюро 88», в лице генерального директора Дяченко Софии Александровны, действующего на основании Устава, именуемое в дальнейшем «Исполнитель» с одной стороны и " +
      form.clientType.fio +
      " (" +
      form.clientType.otherDetails +
      ")" +
      ", с другой стороны, в дальнейшем именуемый «Заказчик», подписали настоящий акт о нижеследующем:"
    );
  }
}

function GetStartText(form) {
  if (form.clientType.type === "ю.л.") {
    if (form.clientType.ofp === "ИП") {
      return [new TextRun({
        text: `Общество с ограниченной ответственностью «ЮрБюро 88», именуемое в дальнейшем «Исполнитель», в лице Генерального директора Дяченко Софии Александровны, действующего на основании Устава, с одной стороны и `,
        size: 18
      }),
        new TextRun({
          text: `${GetOfp(
              form.clientType.ofp,
              form.clientType.fullofp,
              form.clientType.shortofp
          )} ${form.clientType.name}`,
          size: 18,
          bold:true
        }),
        new TextRun({
          text: `, ОГРНИП ${form.clientType.ogrn}, с другой стороны, в дальнейшем именуемый «Заказчик», заключили данный договор о том, что:`,
          size: 18
        }),
      ]
    }
    return [new TextRun({
      text: `Общество с ограниченной ответственностью «ЮрБюро 88», именуемое в дальнейшем «Исполнитель», в лице Генерального директора Дяченко Софии Александровны, действующего на основании Устава, с одной стороны и `,
      size: 18
    }),
    new TextRun({
      text: `${GetOfp(
        form.clientType.ofp,
        form.clientType.fullofp,
        form.clientType.shortofp
      )} «${form.clientType.name}» `,
      size: 18,
      bold:true
    }),
    new TextRun({
      text: `в лице Генерального директора `,
      size: 18
    }),
    new TextRun({
      text: `${form.clientType.inface}`,
      size: 18,
      bold:true
    }),
    new TextRun({
      text: `, действующего на основании Устава, с другой стороны, в дальнейшем именуемое «Заказчик», заключили данный договор о том, что:`,
      size: 18
    }),
  ]
  }
  if (form.clientType.type === "ф.л.") {
    return [new TextRun({
      text: `Общество с ограниченной ответственностью «ЮрБюро 88», именуемое в дальнейшем «Исполнитель», в лице Генерального директора Дяченко Софии Александровны, действующего на основании Устава, с одной стороны и `,
      size: 18
    }),
    new TextRun({
      text: `${form.clientType.fio} (${form.clientType.otherDetails})`,
      size: 18,
      bold:true
    }),
    new TextRun({
      text: `, с другой стороны, в дальнейшем именуемый «Заказчик», заключили данный договор о том, что:`,
      size: 18
    }),
  ]
  }
}

function GetRaschet(
  method,
  totalPrice,
  vneseno,
  ostatok,
  thirdPersonPayment,
  thirdPersonDetails
) {
  if (thirdPersonPayment) {
    switch (method) {
      case "Безналичный расчет":
        return (
          "За Заказчика (по его поручению/заявлению) вносит оплату " +
          thirdPersonDetails +
          " в течение 3-х рабочих дней  в размере " +
          totalPrice +
          " (" +
          number_to_string(totalPrice) +
          ") рублей, путем перечисления денежных средств на расчетный счет Исполнителя . При этом ответственность за неоплату/несвоевременную оплату перед Исполнителем несет Заказчик"
        );
        break;
      case "Наличный расчет":
        return (
          "За Заказчика (по его поручению/заявлению) вносит оплату " +
          thirdPersonDetails +
          " в размере " +
          vneseno +
          " (" +
          number_to_string(vneseno) +
          ") рублей наличными денежными средствами в момент подписания настоящего договора, остаток составляет " +
          ostatok +
          " (" +
          number_to_string(ostatok) +
          ") рублей . При этом ответственность за неоплату/несвоевременную оплату перед Исполнителем несет Заказчик"
        );
        break;
      case "ИП":
        return "Индивидуальный предприниматель (ИП)";
        break;
      case "Иное":
        return;
        break;
      default:
        return "";
    }
  } else {
    switch (method) {
      case "Безналичный расчет":
        return (
          "Заказчик вносит оплату в течение 3-х рабочих дней в размере " +
          totalPrice +
          " (" +
          number_to_string(totalPrice) +
          ") рублей путём перечисления денежных средств на расчётный счёт Исполнителя"
        );
        break;
      case "Наличный расчет":
        return (
          "Заказчик вносит оплату в размере " +
          vneseno +
          " (" +
          number_to_string(vneseno) +
          ") рублей наличными денежными средствами в момент подписания настоящего договора, остаток составляет " +
          ostatok +
          " (" +
          number_to_string(ostatok) +
          ") рублей"
        );
        break;
      case "ИП":
        return "Индивидуальный предприниматель (ИП)";
        break;
      case "Иное":
        return;
        break;
      default:
        return "";
    }
  }
}

function GetOfp(ofp, fullofp, shortofp) {
  switch (ofp) {
    case "ООО":
      return "Общество с ограниченной ответственностью";
      break;
    case "АО":
      return "Акционерное общество";
      break;
    case "ИП":
      return "Индивидуальный предприниматель";
      break;
    case "Иное":
      return fullofp;
      break;
    default:
      return "";
  }
}

function GetUslugaAdv(adv, index) {
  switch (index) {
    case 0:
      if (adv === true) {
        return " единоличном исполнительном органе,";
        break;
      }
      return "";
      break;
    case 1:
      if (adv === true) {
        return " адресе местонахождения,";
        break;
      }
      return "";
      break;
    case 2:
      if (adv === true) {
        return " составе участников,";
        break;
      }
      return "";
      break;
    case 3:
      if (adv === true) {
        return " видах экономической деятельности,";
        break;
      }
      return "";
      break;
    case 4:
      if (adv === true) {
        return " изменении размера УК,";
        break;
      }
      return "";
      break;
    case 5:
      if (adv !== '') {
        if (adv !== null ){
        return " " + adv + ",";
        break;
        }
      }
      return "";
      break;
    default:
      return "";
  }
}

function GetUslugaAdvPervich(adv, index, named) {
  let name = named.replace(/"/, '«')
  name = name.replace(/"/, '»')
  switch (index) {
    case 0:
      if (adv === true) {
        return `Подготовка документов для государственной регистрации ${name}, `;
        break;
      }
      return "";
      break;
    case 1:
      if (adv === true) {
        return `Подача и получение документов в регистрирующем органе для государственной регистрации ${name}, `;
        break;
      }
      return "";
      break;
    default:
      return "";
  }
}

function GetUslugaAdvRemoving(adv, index) {
  switch (index) {
    case 0:
      if (adv === true) {
        return `Подготовка необходимого комплекта документов на государственную регистрацию прекращения деятельности Общества, `;
        break;
      }
      return "";
      break;
    case 1:
      if (adv === true) {
        return `Подача необходимых документов в регистрирующий орган и получение документов, подтверждающих гос. регистрацию уведомления о составлении  промежуточного баланса, ликвидационного баланса, а также документов, подтверждающих регистрацию прекращения деятельности Общества, `;
        break;
      }
      return "";
      break;
    case 2:
      if (adv === true) {
        return `Содействие в получении справок о состоянии расчетов Общества с налоговой инспекцией, пенсионным фондом и фондом социального страхования, `;
        break;
      }
      return "";
      break;
    default:
      return "";
  }
}

function GetUsluga(usluga) {
  switch (usluga.type) {
    case "2":
      const adv = usluga.adv.map((elem, index) => {
        return GetUslugaAdv(elem, index);
      });
      return (
        "Подготовка документов для государственной регистрации изменений, вносимых в ЕГРЮЛ в части сведений о" +
        adv.join("").slice(0, -1)
      );
      break;
    case "3":
      const advPervich = usluga.adv.map((elem, index) => {
        return GetUslugaAdvPervich(elem, index, usluga.name);
      });
      return advPervich.join("").slice(0, -2);
      break;
    case "4":
      const advRemoving = usluga.adv.map((elem, index) => {
        return GetUslugaAdvRemoving(elem, index, usluga.name);
      });
      return advRemoving.join("").slice(0, -2);
      break;
    case "5":
      return "Подача необходимых документов в регистрирующий орган и получение документов, подтверждающих гос. регистрацию уведомления о составлении промежуточного баланса, ликвидационного баланса, а также документов, подтверждающих регистрацию прекращения деятельности Общества";
      break;
    case "6":
      return "Содействие в получении справок о состоянии расчетов Общества с налоговой инспекцией, пенсионным фондом и фондом социального страхования";
      break;
    case "7":
      return "Содействие в получении ЭЦП Заказчика";
      break;
    case "8":
      return "Содействие в предоставлении юридического адреса";
      break;
    case "9":
      return "Представление интересов в государственных органах и кредитных организациях";
      break;
    case "10":
      return "Консультации в области корпоративного права";
      break;
    case "11":
      return "Постановка на учет в пробирной палате";
      break;
    case "12":
      return (
        "Содействие в представлении документов в регистрирующий орган"
      );
      break;
    case "13":
      return usluga.other;
      break;
    default:
      return "";
  }
}

function str_split(string, length) {
  var chunks, len, pos;

  string = string == null ? "" : string;
  length = length == null ? 1 : length;

  var chunks = [];
  var pos = 0;
  var len = string.length;
  while (pos < len) {
    chunks.push(string.slice(pos, (pos += length)));
  }

  return chunks;
}
function morph(number, titles) {
  var cases = [2, 0, 1, 1, 1, 2];
  var lastTwo = Number(number) % 100;
  if (lastTwo > 4 && lastTwo < 20) {
    return titles[2];
  }
  var last = lastTwo % 10;
  return titles[cases[Math.min(last, 5)]];
}
function number_to_string(num) {
  var def_translite = {
    null: "ноль",
    a1: [
      "один",
      "два",
      "три",
      "четыре",
      "пять",
      "шесть",
      "семь",
      "восемь",
      "девять",
    ],
    a2: [
      "одна",
      "две",
      "три",
      "четыре",
      "пять",
      "шесть",
      "семь",
      "восемь",
      "девять",
    ],
    a10: [
      "десять",
      "одиннадцать",
      "двенадцать",
      "тринадцать",
      "четырнадцать",
      "пятнадцать",
      "шестнадцать",
      "семнадцать",
      "восемнадцать",
      "девятнадцать",
    ],
    a20: [
      "двадцать",
      "тридцать",
      "сорок",
      "пятьдесят",
      "шестьдесят",
      "семьдесят",
      "восемьдесят",
      "девяносто",
    ],
    a100: [
      "сто",
      "двести",
      "триста",
      "четыреста",
      "пятьсот",
      "шестьсот",
      "семьсот",
      "восемьсот",
      "девятьсот",
    ],
    uc: ["копейка", "копейки", "копеек"],
    ur: ["рубль", "рубля", "рублей"],
    u3: ["тысяча", "тысячи", "тысяч"],
    u2: ["миллион", "миллиона", "миллионов"],
    u1: ["миллиард", "миллиарда", "миллиардов"],
  };
  var i1, i2, i3, kop, out, rub, v, zeros, _ref, _ref1, _ref2, ax;

  // нормализуем вход: убираем разделители тысяч (пробел/запятую)
  if (typeof num === "number" || typeof num === "bigint") {
    num = String(num);
  } else {
    num = String(num).replace(/\s+/g, "");
    if (/^\d+,\d{3}$/.test(num) || /^\d+,\d{3},\d{3}$/.test(num)) {
      num = num.replace(/,/g, "");
    } else {
      num = num.replace(",", ".");
    }
  }

  _ref = parseFloat(num).toFixed(2).split(".");
  rub = _ref[0];
  kop = _ref[1];
  var leading_zeros = 12 - rub.length;
  if (leading_zeros < 0) {
    return false;
  }

  var zeros = [];
  while (leading_zeros--) {
    zeros.push("0");
  }
  rub = zeros.join("") + rub;
  var out = [];
  if (rub > 0) {
    // Разбиваем число по три символа
    _ref1 = str_split(rub, 3);
    for (var i = -1; i < _ref1.length; i++) {
      v = _ref1[i];
      if (!(v > 0)) continue;
      _ref2 = str_split(v, 1);
      i1 = parseInt(_ref2[0]);
      i2 = parseInt(_ref2[1]);
      i3 = parseInt(_ref2[2]);
      out.push(def_translite.a100[i1 - 1]); // 1xx-9xx
      ax = i + 1 == 3 ? "a2" : "a1";
      if (i2 > 1) {
        out.push(
          def_translite.a20[i2 - 2] +
            (i3 > 0 ? " " + def_translite[ax][i3 - 1] : "")
        ); // 20-99
      } else {
        out.push(i2 > 0 ? def_translite.a10[i3] : def_translite[ax][i3 - 1]); // 10-19 | 1-9
      }

      if (_ref1.length > i + 1) {
        var name = def_translite["u" + (i + 1)];
        out.push(morph(v, name));
      }
    }
  } else {
    out.push(def_translite.null);
  }
  // Дописываем название "рубли"
  // out.push(morph(rub, def_translite.ur));
  // Дописываем название "копейка"
  // out.push(kop + " " + morph(kop, def_translite.uc));

  // Объединяем маcсив в строку, удаляем лишние пробелы и возвращаем результат
  let res = out.join(" ").replace(RegExp(" {2,}", "g"), " ").trimLeft();
  if (res.charAt(res.length - 1) === ' ') {
    res = res.slice(0, -1)
  }
  return res
}

const GeneratePrilojenie = async (form, formedId) => {
  const table = new Table({
    width: {
      // size: 8535,
      size: 1770,
      type: WidthType.DXA,
      // size: "100%",
      // type: WidthType.PERCENTAGE
    },
    rows: [
      new TableRow({
        children: [
          new TableCell({
            width: {
              size: "16%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("Полная:")],
          }),
          new TableCell({
            width: {
              size: "16%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph(form.totalPrice)],
          }),
          new TableCell({
            width: {
              size: "16%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("Внесенная:")],
          }),
          new TableCell({
            width: {
              size: "16%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph(form.vneseno ? form.vneseno : "-")],
          }),
          new TableCell({
            width: {
              size: "16%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("Остаток:")],
          }),
          new TableCell({
            width: {
              size: "16%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph(form.ostatok ? form.ostatok : "-")],
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            width: {
              size: "100%",
              type: WidthType.PERCENTAGE,
            },
            columnSpan: 6,
            children: [new Paragraph("Адрес местонахождения:")],
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            width: {
              size: "100%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("Учредители:")],
            columnSpan: 6,
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("Генеральный директор")],
            columnSpan: 3,
          }),
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("")],
            columnSpan: 3,
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("Телефон и почта для налоговой")],
            columnSpan: 3,
          }),
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph(form.phone + ", " + form.email)],
            columnSpan: 3,
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("Размер УК")],
            columnSpan: 3,
          }),
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("")],
            columnSpan: 3,
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("Система налогообложения")],
            columnSpan: 3,
          }),
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("")],
            columnSpan: 3,
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("Банк")],
            columnSpan: 3,
            borders: {
              bottom: {
                style: BorderStyle.NONE,
                size: 0,
                color: "ffffff",
              },
            },
          }),
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            borders: {
              bottom: {
                style: BorderStyle.NONE,
                size: 0,
                color: "ffffff",
              },
            },
            children: [new Paragraph("")],
            columnSpan: 3,
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("Тел+почта для банка")],
            borders: {
              top: {
                style: BorderStyle.NONE,
                size: 0,
                color: "ffffff",
              },
            },
            columnSpan: 3,
          }),
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("")],
            borders: {
              top: {
                style: BorderStyle.NONE,
                size: 0,
                color: "ffffff",
              },
            },
            columnSpan: 3,
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            width: {
              size: "100%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("ОКВЭД")],
            columnSpan: 6,
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("Дополнительно")],
            columnSpan: 3,
          }),
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("")],
            columnSpan: 3,
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("Печать")],
            columnSpan: 3,
          }),
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("")],
            columnSpan: 3,
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("Контактный телефон:")],
            columnSpan: 3,
            borders: {
              bottom: {
                style: BorderStyle.NONE,
                size: 0,
                color: "ffffff",
              },
            },
          }),
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            borders: {
              bottom: {
                style: BorderStyle.NONE,
                size: 0,
                color: "ffffff",
              },
            },
            children: [new Paragraph(form.details)],
            columnSpan: 3,
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("Email:")],
            borders: {
              top: {
                style: BorderStyle.NONE,
                size: 0,
                color: "ffffff",
              },
            },
            columnSpan: 3,
          }),
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("")],
            borders: {
              top: {
                style: BorderStyle.NONE,
                size: 0,
                color: "ffffff",
              },
            },
            columnSpan: 3,
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("   ИСПОЛНИТЕЛЬ:")],
            columnSpan: 3,
            borders: {
              bottom: {
                style: BorderStyle.NONE,
                size: 0,
                color: "ffffff",
              },
            },
          }),
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            borders: {
              bottom: {
                style: BorderStyle.NONE,
                size: 0,
                color: "ffffff",
              },
            },
            children: [new Paragraph("   ЗАКАЗЧИК:")],
            columnSpan: 3,
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("")],
            borders: {
              top: {
                style: BorderStyle.NONE,
                size: 0,
                color: "ffffff",
              },
            },
            columnSpan: 3,
          }),
          new TableCell({
            width: {
              size: "50%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph("")],
            borders: {
              top: {
                style: BorderStyle.NONE,
                size: 0,
                color: "ffffff",
              },
            },
            columnSpan: 3,
          }),
        ],
      }),
    ],
  });
  const doc = new Document({
    styles: {
      // spacing: { before: 0, after: 0, line: 0 },
      paragraphStyles: [
        {
          id: "myWonkyStyle",
          name: "My Wonky Style",
          basedOn: "Normal",
          next: "Normal",
          quickFormat: true,
          run: {
            // italics: true,
            // color: "999999",
            size: 18,
          },
          paragraph: {
            spacing: {
              // before: 0,
              // after: 0
              // line: 276,
            },
            indent: {
              left: -568.18,
              right: 45.45,
            },
          },
        },
        {
          id: "myWonkyStyle2",
          name: "My Wonky Style 2",
          basedOn: "Normal",
          next: "Normal",
          quickFormat: true,
          run: {
            // italics: true,
            // color: "999999",
          },
          paragraph: {
            spacing: {
              // before: 0,
              // after: 0
              // line: 276,
            },
            indent: {
              left: -284.09,
              right: 45.45,
            },
          },
        },
        {
          id: "Heading2",
          name: "Heading 2",
          basedOn: "Normal",
          next: "Normal",
          quickFormat: true,
          run: {
            size: 26,
            bold: true,
          },
          paragraph: {
            spacing: {
              before: 240,
              after: 120,
            },
          },
        },
      ],
    },
    properties: {
      page: {
        margin: {
          top: 500,
          right: 1000,
          bottom: 500,
          left: 1000,
        },
      },
    },
    sections: [
      {
        children: [
          new Paragraph({
            style: "myWonkyStyle",
            children: [
              new TextRun({
                text: `Приложение  к договору № ${formedId}  от    ${GetDate(
                  form.date
                )}`,
                size: 24
              }),
            ],
            alignment: AlignmentType.RIGHT,
          }),
          new Paragraph({
            style: "myWonkyStyle",
            children: [
              new TextRun({
                text: form.urist,
                size: 40
              }),
            ],
            alignment: AlignmentType.RIGHT,
          }),
          new Paragraph({
            style: "myWonkyStyle",
            children: [
              new TextRun({
                text: "Общество с ограниченной ответственностью",
                size: 40
              }),
              
            ],
            alignment: AlignmentType.CENTER,
          }),
          new Paragraph({
            style: "myWonkyStyle",
            children: [
              new TextRun({
                text: `«${
                  form.clientType.type === "ю.л."
                    ? form.clientType.name
                    : form.clientType.fio
                }»`,
                size: 40
              }),
            ],
            alignment: AlignmentType.CENTER,
          }),
          table,
        ],
      },
    ],
  });
  Packer.toBlob(doc).then((blob) => {
    saveAs(blob, "Приложение к договору.docx");
  });
};

const GenerateSchet = async (form, formedId, schetId, date) => {
  const img = await fetch(
    // "https://sun9-34.userapi.com/impg/qiQ2bAGv9t1t9W8cYA283RXmGx1l_OKw2PQLpg/kvS6bVAyiB8.jpg?size=661x182&quality=96&sign=b52fd5f60026b02d3026e80c082b25a8&type=album"
    // "https://i.ibb.co/3W9QwLb/image.png"
    // "https://i.ibb.co/74q5YQs/image.png"
    // "https://i.ibb.co/mzwfSTT/image.png"
    // "https://i.ibb.co/dLZDgfZ/2.png"
    // "https://i.ibb.co/PMyjw9b/w.png"
    "/images/novaya/pechat2.png"
).then((r) => r.blob());
  const table = new Table({
    float: {
      // horizontalAnchor: TableAnchorType.MARGIN,
      // relativeHorizontalPosition: RelativeHorizontalPosition.LEFT,
      relativeHorizontalPosition: 100,
  },
  indent: {
    size: -1000,
    type: WidthType.NIL,
},
    columnWidths: [350, 5505],
    rows: [
      new TableRow({
        children: [
          new TableCell({
            width: {
              size: "5%",
              type: WidthType.PERCENTAGE,
            },
            margins: {
              left: -100,
          },
            children: [new Paragraph({
              children: [
                new TextRun({
                  text:"№",
                  size:24
                }),
              ],
            alignment: AlignmentType.CENTER,})],
          }),
          new TableCell({
            width: {
              size: "40%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph({
              children: [
                new TextRun({
                  text:"Наименование",

                  size:24
                }),
              ],
            alignment: AlignmentType.CENTER,})],
          }),
          new TableCell({
            width: {
              size: "13%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph({
              children: [
                new TextRun({
                  text:"Ед. изм.",

                  size:24
                }),
              ],
            alignment: AlignmentType.CENTER,})],
          }),
          new TableCell({
            width: {
              size: "13%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph({
              children: [
                new TextRun({
                  text:"Кол-во",

                  size:24
                }),
              ],
            alignment: AlignmentType.CENTER,})],
          }),
          new TableCell({
            width: {
              size: "13%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph({
              children: [
                new TextRun({
                  text:"Цена",

                  size:24
                }),
              ],
            alignment: AlignmentType.CENTER,})],
          }),
          new TableCell({
            width: {
              size: "13%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph({
              children: [
                new TextRun({
                  text:"Сумма",

                  size:24
                }),
              ],
            alignment: AlignmentType.CENTER,})],
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            width: {
              size: "5%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph({
              children: [
                new TextRun({
                  text:"1",
                  size:24
                }),
              ],
              
            alignment: AlignmentType.CENTER,})],
          }),
          new TableCell({
            width: {
              size: "40%",
              type: WidthType.PERCENTAGE,
            },
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text:"Оказание юридических услуг по договору " +
              formedId +
              " от " +
              form.date,
                    size:24
                  }),
                ],
                
              alignment: AlignmentType.CENTER,}
                
              ),
            ],
          }),
          new TableCell({
            width: {
              size: "13%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph({
              children: [
                new TextRun({
                  text:"шт",

                  size:24
                }),
              ],
            alignment: AlignmentType.CENTER,})],
          }),
          new TableCell({
            width: {
              size: "13%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph({
              children: [
                new TextRun({
                  text:"1",
                  size:24
                }),
              ],
            alignment: AlignmentType.CENTER,})],
          }),
          new TableCell({
            width: {
              size: "13%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph({
              children: [
                new TextRun({
                  text:form.totalPrice,
                  size:24
                }),
              ],
            alignment: AlignmentType.CENTER,})],
          }),
          new TableCell({
            width: {
              size: "13%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph({
              children: [
                new TextRun({
                  text:form.totalPrice,
                  size:24
                }),
              ],
              alignment: AlignmentType.CENTER,})],
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            width: {
              size: "10%",
              type: WidthType.PERCENTAGE,
            },
            children: [new Paragraph({
              children: [
                new TextRun({
                  text:"Итого:      " + form.totalPrice,
                  size:24
                }),
              ],
            })],
            columnSpan: 6,
          }),
        ],
      }),
    ],
  });
  const doc = new Document({
    styles: {
      spacing: { before: 0, after: 0, line: 0 },
      table: {
        table: {
          spacing: -100
        }
      },
      paragraphStyles: [
        {
          id: "myWonkyStyle",
          name: "My Wonky Style",
          basedOn: "Normal",
          next: "Normal",
          quickFormat: true,
          run: {
            // italics: true,
            // color: "999999",
            size: 24,
          },
          paragraph: {
            spacing: {
              // before: 0,
              // after: 0
              // line: 276,
            },
            indent: {
              // left: -568.18,
              // right: 45.45,
            },
          },
        },
        {
          id: "myWonkyStyle2",
          name: "My Wonky Style 2",
          basedOn: "Normal",
          next: "Normal",
          quickFormat: true,
          run: {
            // italics: true,
            // color: "999999",
          },
          paragraph: {
            spacing: {
              // before: 0,
              // after: 0
              // line: 276,
            },
            indent: {
              left: -284.09,
              right: 45.45,
            },
          },
        },
        {
          id: "Heading2",
          name: "Heading 2",
          basedOn: "Normal",
          next: "Normal",
          quickFormat: true,
          run: {
            size: 26,
            bold: true,
          },
          paragraph: {
            spacing: {
              before: 240,
              after: 120,
            },
          },
        },
      ],
    },
    sections: [
      {
        properties: {
          page: {
            margin: {
              left: 1000,
            },
          },
        },
        children: [
          new Paragraph({
            style: "myWonkyStyle",
            children: [
              new TextRun({
                text: "Продавец: ООО «ЮрБюро 88»",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            children: [
              new TextRun({
                text: "Адрес: 191014, Санкт-Петербург, МО Литейный, Невский пр-кт, д. 88, литера А, помещение 33-Н, офис 6",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            children: [
              new TextRun({
                text: "ИНН: 7840131675",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            children: [
              new TextRun({
                text: "КПП: 784001001",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            children: [
              new TextRun({
                text: 'Банк: Филиал Центральный Банка ВТБ (ПАО)',
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            children: [
              new TextRun({
                text: "Кор. счет: 30101810145250000411",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            children: [
              new TextRun({
                text: "Расчетный счет: 40702810590810033838",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            children: [
              new TextRun({
                text: "БИК: 044525411",
              }),
            ],
          }),
          new Paragraph({
            text: "",
            style: "myWonkyStyle",
          }),
          new Paragraph({
            text: "",
            style: "myWonkyStyle",
          }),
          ...GetClientName(form),
          new Paragraph({
            text: "",
            style: "myWonkyStyle",
          }),
          new Paragraph({
            text: "",
            style: "myWonkyStyle",
          }),
          new Paragraph({
            // text: "Счет № " + formedId + " от " + form.date,
            style: "myWonkyStyle",
            alignment: AlignmentType.CENTER,
            children: [
              new TextRun({
                text:
                "Счет № " + (schetId ? schetId : formedId) + " от " + (date ? date : form.date),
                size: 24,
              }),
            ]
          }),
          new Paragraph({
            text: "",
            style: "myWonkyStyle",
          }),
          table,
          new Paragraph({
            text: "",
            style: "myWonkyStyle",
          }),
          new Paragraph({
            style: "myWonkyStyle",
            children: [
              new TextRun({
                text:
                  "Cумма прописью: " +
                  number_to_string(form.totalPrice) +
                  " рублей 00 коп. Без НДС",
              }),
            ],
          }),
          new Paragraph({
            text: "",
            style: "myWonkyStyle",
          }),
          new Paragraph({
            text: "",
            style: "myWonkyStyle",
          }),
          new Paragraph({
            children: [
              new ImageRun({
                data: img,
                transformation: {
                  width: 488, //284 183
                  height: 187,
                },
              }),
            ],
          }),
        ],
      },
    ],
  });
  Packer.toBlob(doc).then((blob) => {
    saveAs(blob, "Счет.docx");
  });
};

const GenerateAct = async (form, formedId, schetId) => {
  const img = await fetch(
    // "https://sun9-33.userapi.com/impg/l8w7Z0Gk0TtOPnC7t-x4yImlUBsGbGSUnV7t-w/PpSGEZaPq_g.jpg?size=193x174&quality=96&sign=ccd09af4ee2b14d25b63795ba6e79dc4&type=album"
    // "https://i.ibb.co/JymSq5V/image.png"
    // "https://i.ibb.co/dKXRZVQ/image.png"
    // "https://i.ibb.co/Q8J8MJX/image.png"
    // "https://i.ibb.co/FV1w5Z9/2.png"
    // "https://i.ibb.co/7b00VY0/q.png"
    "/images/novaya/pechat.png"
).then((r) => r.blob());
  const table = new Table({
    columnWidths: [5000, 5000],
    rows: [
      new TableRow({
        children: [
          new TableCell({
            borders: {
              top: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
              bottom: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
              left: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
              right: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
            },
            width: {
              size: 5000,
              type: WidthType.DXA,
            },
            children: [new Paragraph(
              {children: [
                new TextRun({
                  text:"Исполнитель:",
                  size:24,
                  bold: true
                }),
              ],
            })],
          }),
          new TableCell({
                        borders: {
              top: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
              bottom: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
              left: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
              right: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
            },
            width: {
              size: 5000,
              type: WidthType.DXA,
            },
            children: [new Paragraph({children: [
              new TextRun({
                text:"Заказчик:",
                size:24,
                bold: true
              }),
            ],}
            )],
          }),
        ],
      }),
      new TableRow({
                children: [
          new TableCell({
            borders: {
              top: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
              bottom: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
              left: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
              right: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
            },
            width: {
              size: 5000,
              type: WidthType.DXA,
            },
            children: [
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "ООО «ЮрБюро 88»", size: 24 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "Адрес: 191014, Санкт-Петербург,", size: 24 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "МО Литейный, Невский пр-кт, д. 88,", size: 24 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "литера А, помещение 33-Н, офис 6", size: 24 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "ОГРН: 1267800065774", size: 24 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "ИНН/КПП: 7840131675/784001001", size: 24 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "Банк: Филиал Центральный Банка ВТБ (ПАО)", size: 24 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "р/с: 40702810590810033838", size: 24 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "БИК: 044525411", size: 24 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "к/с: 30101810145250000411", size: 24 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "Тел.: +7 812 611 01 41; +7 921 913 05 35", size: 24 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "Эл. почта: 6110141@gmail.com; n61110141n@yandex.ru", size: 24 })] }),
              // new Paragraph("Генеральный директор"),
              new Paragraph(
                {children: [
                new TextRun({
                  text:"Генеральный директор",
                  size:24
                }),
              ],}),
              new Paragraph({
                children: [
                  new ImageRun({
                    data: img,
                    transformation: {
                      width: 214, //232 160
                      height: 176,
                    },
                  }),
                ],
              }),
              // new Paragraph(""),
              // new Paragraph(""),
              // new Paragraph("______________ /Синевич А.А./"),,
            ],
          }),
          GetReqAct(form),
        ],
      }),
    ],
  });
  const doc = new Document({
    styles: {
      spacing: { before: 0, after: 0, line: 0 },
      paragraphStyles: [
        {
          id: "myWonkyStyle",
          name: "My Wonky Style",
          basedOn: "Normal",
          next: "Normal",
          quickFormat: true,
          run: {
            // italics: true,
            // color: "999999",
            size: 24,
          },
          paragraph: {
            spacing: {
              // before: 0,
              // after: 0
              // line: 276,
            },
            indent: {
              left: -568.18,
              right: 45.45,
            },
          },
        },
        {
          id: "myWonkyStyle2",
          name: "My Wonky Style 2",
          basedOn: "Normal",
          next: "Normal",
          quickFormat: true,
          run: {
            // italics: true,
            // color: "999999",
          },
          paragraph: {
            spacing: {
              // before: 0,
              // after: 0
              // line: 276,
            },
            indent: {
              left: -284.09,
              right: 45.45,
            },
          },
        },
        {
          id: "Heading2",
          name: "Heading 2",
          basedOn: "Normal",
          next: "Normal",
          quickFormat: true,
          run: {
            size: 26,
            bold: true,
          },
          paragraph: {
            spacing: {
              before: 240,
              after: 120,
            },
          },
        },
      ],
    },
    sections: [
      {
        children: [
          new Paragraph({
            children: [
              new TextRun({
                text: "Акт № " + (schetId ? schetId : formedId),
                bold: true
              }),
            ],
            alignment: "center",
            style: "myWonkyStyle",
          }),
          new Paragraph({
            children: [
              new TextRun({
                text: "об оказании услуг",
                bold: true
              }),
            ],
            alignment: "center",
            style: "myWonkyStyle",
          }),
          new Paragraph({
            style: "myWonkyStyle",
            children: [
              new TextRun({
                text: "",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            children: [
              new TextRun({
                text: "г. Санкт-Петербург                                                                                    «__» ________ 202_ г.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            children: [
              new TextRun({
                text: "",
              }),
            ],
            alignment: AlignmentType.JUSTIFIED,
          }),
          new Paragraph({
            text: GetStartTextAct(form),
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
          }),
          new Paragraph({
            children: [
              new TextRun({
                text: "",
              }),
            ],
            alignment: AlignmentType.JUSTIFIED,
            style: "myWonkyStyle",
          }),
          new Paragraph({
            style: "myWonkyStyle",
            children: [
              new TextRun({
                text:
                  "1.  Исполнителем по заданию Заказчика и в соответствии с п. 1.2. Договора № " +
                  formedId +
                  " от " +
                  form.date +
                  " оказаны юридические услуги, своевременно и надлежащим образом.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            children: [
              new TextRun({
                text: "2. Претензий со стороны Заказчика к Исполнителю не имеется.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            children: [
              new TextRun({
                text:
                  "3.  Стоимость оказанных услуг составила " +
                  form.totalPrice +
                  " (" +
                  number_to_string(form.totalPrice) +
                  ") рублей 00 коп. Исполнитель применяет упрощенную систему налогообложения, но в соответствии п. 1 ст. 145 НК РФ, освобожден от исполнения обязанности по исчислению и уплате НДС.",
              }),
            ],
          }),
          new Paragraph({
            children: [
              new TextRun({
                text: "4. Подписи Сторон",
              }),
            ],
            style: "myWonkyStyle",
          }),
          new Paragraph(""),
          table,
        ],
      },
    ],
  });
  Packer.toBlob(doc).then((blob) => {
    saveAs(blob, "Акт.docx");
  });
};

const GenerateDogovor = async (form, formedId) => {
  const img = await fetch(
    // "https://sun9-33.userapi.com/impg/l8w7Z0Gk0TtOPnC7t-x4yImlUBsGbGSUnV7t-w/PpSGEZaPq_g.jpg?size=193x174&quality=96&sign=ccd09af4ee2b14d25b63795ba6e79dc4&type=album"
    // "https://i.ibb.co/JymSq5V/image.png"
    // "https://i.ibb.co/dKXRZVQ/image.png"
    // "https://i.ibb.co/Q8J8MJX/image.png"https://ibb.co/5Gs9n09
    // "https://i.ibb.co/7b00VY0/q.png"
    "/images/novaya/pechat.png"
  ).then((r) => r.blob());
  const table = new Table({
    alignment: AlignmentType.CENTER,
    indent: {
      size: 600,
      type: WidthType.DXA,
  },
    columnWidths: [5000, 5000],
    rows: [
      new TableRow({
        children: [
          new TableCell({
            borders: {
              top: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
              bottom: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
              left: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
              right: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
            },
            width: {
              size: 5000,
              type: WidthType.DXA,
            },
            children: [new Paragraph("Исполнитель:")],
          }),
          new TableCell({
            borders: {
              top: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
              bottom: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
              left: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
              right: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
            },
            width: {
              size: 5000,
              type: WidthType.DXA,
            },
                        children: [new Paragraph("Заказчик:")],
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            borders: {
              top: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
              bottom: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
              left: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
              right: {
                style: BorderStyle.NONE,
                size: 0,
                color: "FFFFFF",
              },
            },
            width: {
              size: 5000,
              type: WidthType.DXA,
            },
            children: [
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "ООО «ЮрБюро 88»", size: 18 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "Адрес: 191014, Санкт-Петербург, МО Литейный,", size: 18 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "Невский пр-кт, д. 88, литера А, помещение 33-Н, офис 6", size: 18 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "ОГРН: 1267800065774", size: 18 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "ИНН/КПП: 7840131675/784001001", size: 18 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "Банк: Филиал Центральный Банка ВТБ (ПАО)", size: 18 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "р/с: 40702810590810033838", size: 18 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "БИК: 044525411", size: 18 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "к/с: 30101810145250000411", size: 18 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "Тел.: +7 812 611 01 41; +7 921 913 05 35", size: 18 })] }),
              new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: "Эл. почта: 6110141@gmail.com; n61110141n@yandex.ru", size: 18 })] }),
              // new Paragraph(""),
              // new Paragraph("Генеральный директор"),
              new Paragraph(
                {children: [
                new TextRun({
                  text:"Генеральный директор",
                  size:22
                }),
              ],}),
              // new ImageRun({
              //     data: img,
              //     transformation: {
              //         width: 193,
              //         height: 174,
              //     },
              // }),
              new Paragraph({
                children: [
                  new ImageRun({
                    data: img,
                    transformation: {
                      width: 214, //237 185
                      height: 176,
                    },
                  }),
                ],
              }),
              // new Paragraph(""),
              // new Paragraph(""),
              // new Paragraph("______________ /Синевич А.А./"),,
            ],
          }),
          GetReq(form),
        ],
      }),
    ],
  });
  const doc = new Document({
    styles: {
      spacing: { before: 0, after: 0, line: 0 },
      paragraphStyles: [
        {
          id: "myWonkyStyle",
          name: "My Wonky Style",
          basedOn: "Normal",
          next: "Normal",
          quickFormat: true,
          run: {
            // italics: true,
            // color: "999999",
            size: 18,
          },
          paragraph: {
            spacing: {
              // before: 0,
              // after: 0
              // line: 276,
            },
            indent: {
              // left: -852.27,
              // right: -852.27,
              // left: -1136.36,
              // right: -1136.36,
              left: 565,
              right: 565,
            },
          },
        },
        {
          id: "myWonkyStyle2",
          name: "My Wonky Style 2",
          basedOn: "Normal",
          next: "Normal",
          quickFormat: true,
          run: {
            // italics: true,
            // color: "999999",
          },
          paragraph: {
            spacing: {
              // before: 0,
              // after: 0
              // line: 276,
            },
            indent: {
              left: -284.09,
              right: 45.45,
            },
          },
        },
        {
          id: "Heading2",
          name: "Heading 2",
          basedOn: "Normal",
          next: "Normal",
          quickFormat: true,
          run: {
            size: 26,
            bold: true,
          },
          paragraph: {
            spacing: {
              before: 240,
              after: 120,
            },
          },
        },
      ],
    },
    sections: [
      {
        properties: {
          page: {
            margin: {
              top: 500,
              right: 500,
              bottom: 500,
              left: 500,
            },
          },
        },
        children: [
          new Paragraph({
            style: "myWonkyStyle",
            children: [
              new TextRun({
                text:
                  "         ДОГОВОР № " +
                  formedId +
                  " от " +
                  form.date +
                  "                                                                                                            г. Санкт-Петербург",
                bold: true,
              }),
            ],
          }),
          new Paragraph({
            text: '',
            style: "myWonkyStyle",
          }),
          new Paragraph({
            // text: GetStartText(form),
            children: [...GetStartText(form)],
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
          }),
          new Paragraph({
            children: [
              new TextRun({
                text: "         ",
              }),
              new TextRun({
                text: "1. ПРЕДМЕТ ДОГОВОРА.",
                bold: true,
                underline: true,
              }),
            ],
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         1.1. ",
                bold: true,
              }),
              new TextRun({
                text: "Данный договор является смешанным договором с элементами договора возмездного информационно-консультационного оказания услуг, договора поручения и договора безвозмездного хранения.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         1.2. ",
                bold: true,
              }),
              new TextRun({
                text: "В рамках договора возмездного оказания услуг Исполнитель оказывает Заказчику услуги, а именно:",
              }),
            ],
          }),
          ...form.uslugi.map((elem, index) => {
            if (elem.type !== "") {
              return new Paragraph({
                style: "myWonkyStyle",
                alignment: AlignmentType.JUSTIFIED,
                children: [
                  new TextRun({
                    text: "         1.2." + (index + 1).toString() + " ",
                    bold: true,
                  }),
                  new TextRun({
                    text: GetUsluga(elem),
                    bold:true
                  }),
                ],
              });
            }
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         1.3. ",
                bold: true,
              }),
              new TextRun({
                text: "В рамках договора поручения Исполнитель по поручению Заказчика, от имени и за счет Заказчика производит действия, необходимые для исполнения заказа, указанного в п. 1.2. настоящего договора, в том числе передает третьим лицам подлинные документы Заказчика в случае, если это необходимо в интересах Заказчика.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         1.4. ",
                bold: true,
              }),
              new TextRun({
                text: "В рамках договора поручения Исполнитель представляет интересы Заказчика перед третьими лицами (в государственных органах и других организациях).",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         1.5. ",
                bold: true,
              }),
              new TextRun({
                text: "В рамках договора поручения Исполнитель по поручению Заказчика, от имени Заказчика и за счет Заказчика вносит в адрес третьих лиц оплату, а Заказчик возмещает Исполнителю его расходы, связанные с исполнением данного поручения.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         1.6. ",
                bold: true,
              }),
              new TextRun({
                text: "Оплата, которую Исполнитель вносит в рамках договора поручения в адрес третьих лиц, производится в размере равной цене услуг, оказываемых третьими лицами, а также в размере, равном фактически понесенным расходам Исполнителя в связи с исполнением поручения (государственные пошлины, иные обязательные платежи, прочее).",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         1.7. ",
                bold: true,
              }),
              new TextRun({
                text: "Если в процессе выполнения настоящего договора сумма, подлежащая передаче третьим лицам, изменяется в сторону уменьшения, разница между суммой, согласованной сторонами на момент заключения настоящего договора и фактически переданной, считается дополнительным вознаграждением Исполнителя по договору поручения.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         1.8. ",
                bold: true,
              }),
              new TextRun({
                text: "Если в процессе выполнения настоящего договора сумма, подлежащая передаче третьим лицам, изменяется в сторону увеличения, разница между суммой, согласованной на момент заключения настоящего договора и подлежащей фактической выплате третьим лицам, которую нельзя было предусмотреть при заключении договора, компенсируется Заказчиком в соответствующем увеличению размере.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         1.9. ",
                bold: true,
              }),
              new TextRun({
                text: "Заказчик оплачивает услуги Исполнителя в соответствии с условиями данного договора.",
              }),
            ],
          }),
          new Paragraph({
            children: [
              new TextRun({
                text: "         ",
              }),
              new TextRun({
                text: "2. ПРАВА И ОБЯЗАННОСТИ СТОРОН.",
                bold: true,
                underline: true,
              }),
            ],
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
          }),
          new Paragraph({
            children: [
              new TextRun({
                text: "         ",
              }),
              new TextRun({
                text: "2.1. Исполнитель:",
                underline: true,
              }),
            ],
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         2.1.1. ",
                bold: true,
              }),
              new TextRun({
                text: "Обязуется качественно оказать Заказчику услуги, предусмотренные п. 1.2. настоящего договора и выполнить поручения, предусмотренные настоящим договором.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         ",
                bold: true,
              }),
              new TextRun({
                text:
                  "Срок оказания услуг и выполнения поручения (количество рабочих дней) от: " +
                  form.deadline,
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         2.1.2. ",
                bold: true,
              }),
              new TextRun({
                text: "Срок, указанный в п.2.1.1. начинает исчисляться с момента предоставления Заказчиком всех необходимых документов для оказания услуги/выполнения поручения, а в случае, если настоящим договором предусмотрена предоплата, то с момента поступления денежных средств на расчетный счет Исполнителя и предоставления Заказчиком всех необходимых документов для оказания услуги/выполнения поручения. Выдача готовых документов осуществляется в назначенный день и в любой следующий день в течение рабочего времени. Исполнитель не несет ответственности перед Заказчиком в случае несоблюдения стандартных сроков процедур оформления документов со стороны государственных органов, а также при нарушении п.2.2.3.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         2.1.3. ",
                bold: true,
              }),
              new TextRun({
                text: "Исполнитель в случае необходимости по личному заявлению Заказчика принимает на хранение подлинные документы Заказчика. Исполнитель осуществляет хранение подлинных документов заказчика на безвозмездной основе. В соответствие со ст. 891 Гражданского Кодекса РФ, если хранение осуществляется безвозмездно, хранитель обязан заботиться о принятой на хранение вещи не менее, чем о своих вещах.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         2.1.4. ",
                bold: true,
              }),
              new TextRun({
                text: "Исполнитель обязуется хранить подлинные документы Заказчика в течение всего срока договора, а также последующие 14 (четырнадцать) дней с момента выполнения поручения Заказчика, данного настоящим договором.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         ",
                bold: true,
              }),
              new TextRun({
                text: "По истечении указанного срока Исполнитель не несет ответственности за сохранность документов Заказчика.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         2.1.5. ",
                bold: true,
              }),
              new TextRun({
                text: "Исполнитель обязан в течение 5 дней уведомить Заказчика о том, что сумма, подлежащая передаче третьим лицам и согласованная в момент заключения договора, изменилась в сторону увеличения. При этом данный договор считается приостановленным до момента заключения дополнительного соглашения о новых условиях, а в случае несогласия с изменениями условий договора - его расторжение.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         2.1.6. ",
                bold: true,
              }),
              new TextRun({
                text: "В случае невозможности оказания услуг и/или исполнения поручения, (в том числе – части услуг и/или поручения), Исполнитель обязуется уведомить об этом Заказчика в течение 14 (четырнадцати) дней с момента, когда факт невозможности оказания услуг и/или исполнения поручения стал известен Исполнителю. При этом Исполнитель обязан вернуть Заказчику ранее внесенную оплату за фактически не оказанные услуги (не выполненное поручение).  Возврат ранее внесенной оплаты производится в течение 5 дней с момента рассмотрения письменного заявления Заказчика. Рассмотрение заявления осуществляется  Исполнителем в пятидневный срок. При этом исполнитель оставляет за собой право поэтапного возврата суммы, внесенной ранее в качестве оплаты услуг по договору.",
              }),
            ],
          }),
          new Paragraph({
            children: [
              new TextRun({
                text: "         ",
              }),
              new TextRun({
                text: "2.2. Заказчик:",
                underline: true,
              }),
            ],
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         2.2.1. ",
                bold: true,
              }),
              new TextRun({
                text: "Обязуется своевременно оплачивать услуги Исполнителя и своевременно возместить расходы Исполнителя, связанные с выполнением поручения Заказчика.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         2.2.2. ",
                bold: true,
              }),
              new TextRun({
                text: "Своевременно (в срок, необходимый для выполнения Исполнителем поручения) обеспечивать Исполнителя необходимыми документами, в том числе – доверенностями и согласиями (заверенными нотариально).",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         2.2.3. ",
                bold: true,
              }),
              new TextRun({
                text: "Заказчик обязан уведомить Исполнителя обо всех фактах, которые могут препятствовать оказанию услуги, исполнению поручения, в том числе и не легитимности получения предоставляемых документов.  В случае, если у Исполнителя появятся основания полагать, что вышеуказанные факты имеют место быть, Исполнитель может по собственной инициативе затребовать у Заказчика документы, подтверждающие отсутствие таких фактов.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         2.2.4. ",
                bold: true,
              }),
              new TextRun({
                text: "В случае предъявления государственными органами требований о предоставлении дополнительных документов, не оговоренных при заключении настоящего Договора, Заказчик обязан представить необходимые документы. Действие договора приостанавливается до момента предоставления указанных документов.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         2.2.5. ",
                bold: true,
              }),
              new TextRun({
                text: "Исполнитель не несет ответственности за действия (бездействия) государственных, муниципальных и иных официальных органов, а также третьих лиц, привлекаемых в соответствии с п. 1.6. настоящего договора.",
              }),
            ],
          }),
          new Paragraph({
            children: [
              new TextRun({
                text: "         ",
              }),
              new TextRun({
                text: "3. ПОРЯДОК РАСЧЕТОВ И ОТВЕТСТВЕННОСТЬ СТОРОН.",
                bold: true,
                underline: true,
              }),
            ],
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         3.1. ",
                bold: true,
              }),
              new TextRun({
                text:
                  "Общая сумма договора составляет   " +
                  form.totalPrice +
                  " (" +
                  number_to_string(form.totalPrice) +
                  ") ",
              }),
              new TextRun({
                text: "рублей. Исполнитель применяет упрощенную систему налогообложения, но в соответствии п. 1 ст. 145 НК РФ, освобожден от исполнения обязанности по исчислению и уплате НДС.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         3.2. ",
                bold: true,
              }),
              new TextRun({
                text: "Исполнитель представляет Заказчику документы, подтверждающие произведенные им расходы в рамках выполнения договора поручения. ",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         3.3. ",
                bold: true,
              }),
              new TextRun({
                text: GetRaschet(
                  form.paymentMethod,
                  form.totalPrice,
                  form.vneseno,
                  form.ostatok,
                  form.thirdPersonPayment,
                  form.thirdPersonDetails
                ),
              }),
            ],
          }),
          new Paragraph({
            children: [
              new TextRun({
                text: "         ",
              }),
              new TextRun({
                text: "4. ПРОЧИЕ УСЛОВИЯ.",
                bold: true,
                underline: true,
              }),
            ],
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         4.1. ",
                bold: true,
              }),
              new TextRun({
                text: "Стороны обязуются не разглашать информацию (документацию), ставшую им известной в ходе выполнения данного договора, без письменного согласия другой стороны.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         4.2. ",
                bold: true,
              }),
              new TextRun({
                text: "Поручение считается выполненным, а услуга оказанной в день подписания сторонами акта о выполнении работ/услуг. Если в течение 10 дней после направления такого акта Стороной-получателем не был направлен мотивированный отказ от подписания акта, то такой акт считается подписанным Сторонами, а услуги принятыми без замечаний.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         4.3. ",
                bold: true,
              }),
              new TextRun({
                text: "Все изменения и дополнения к договору оформляются в письменной форме и подписываются представителями сторон.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         4.4. ",
                bold: true,
              }),
              new TextRun({
                text: "Стороны признают юридическую силу документов (в том числе настоящего договора, дополнительных соглашений и приложений к нему), подписанных с помощью факсимильного воспроизведения подписи с помощью средств механического или иного копирования либо иного аналога собственноручной подписи.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         4.5. ",
                bold: true,
              }),
              new TextRun({
                text: "Во всех случаях, установленных настоящим Договором, Стороны вправе направлять друг другу уведомления, сообщения и иные документы (в т.ч. договор, дополнительные соглашения и приложения к нему) в электронном виде и/или на бумажных носителях, любым из следующих способов:", //TODO
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         -           ",
              }),
              new TextRun({
                text: "вручение лично (под подпись);",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         -           ",
              }),
              new TextRun({
                text: "направление по почтовым реквизитам, указанным в настоящем Договоре, почтовым отправлением (заказным письмом с уведомлением о вручении);",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         -           ",
                bold: true,
              }),
              new TextRun({
                text: "направление на адрес электронной почты Стороны в сети Интернет, указанной в настоящем Договоре.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         -           ",
                bold: true,
              }),
              new TextRun({
                text: "посредством электронного документооборота.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         4.6. ",
                bold: true,
              }),
              new TextRun({
                text: "Разногласия между сторонами решаются путем непосредственных переговоров. Неурегулированные споры рассматриваются в судебном порядке.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "         4.7. ",
                bold: true,
              }),
              new TextRun({
                text: "Единоличный исполнительный орган Заказчика, в соответствии с положениями статьи 9 Федерального закона от 27 июля 2006 г. № 152-ФЗ «О персональных данных», настоящим подтверждает, что:",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "- ознакомлен, а также являясь представителем учредителей (участников), ознакомил последних с Политикой оператора в отношении обработки персональных данных ООО «ЮрБюро 88».",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "- даю согласие на обработку персональных данных Исполнителем, а также третьими лицами (и их сотрудниками), с которыми у Исполнителя заключены договоры, предусматривающие участие во взаимоотношениях Заказчика и Исполнителя.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "- являясь представителем учредителей (участников), получил от последних согласие на обработку персональных данных Исполнителем, а также третьими лицами (и их сотрудниками), с которыми у Исполнителя заключены договоры, предусматривающие участие во взаимоотношениях Заказчика и Исполнителя.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "Обработка персональных данных совершается с использованием средств автоматизации или без использования таких средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных с целью выполнения Исполнителем своих обязательств, принятых по условиям настоящего Договора.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "Срок использования предоставленных персональных данных - в течении срока действия настоящего Договора.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "Срок хранения предоставленных персональных данных- три года.",
              }),
            ],
          }),
          new Paragraph({
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
            children: [
              new TextRun({
                text: "Способы хранения персональных данных: на электронных носителях, на бумажных носителях.",
              }),
            ],
          }),
          new Paragraph({
            children: [
              new TextRun({
                text: "",
              }),
            ],
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
          }),
          new Paragraph({
            children: [
              new TextRun({
                text: "         ",
              }),
              new TextRun({
                text: "5. РЕКВИЗИТЫ И ПОДПИСИ СТОРОН.",
                bold: true,
                underline: true,
              }),
            ],
            style: "myWonkyStyle",
            alignment: AlignmentType.JUSTIFIED,
          }),
          new Paragraph(""),
          table,
        ],
      },
    ],
  });
  Packer.toBlob(doc).then((blob) => {
    saveAs(blob, "Договор.docx");
  });
};

export const GenerateDoc = async (form, formedId) => {
  GenerateDogovor(form, formedId);
  GenerateAct(form, formedId, false);
  if (form.paymentMethod === "Безналичный расчет") {
    GenerateSchet(form, formedId, false, false);
  }
  // GeneratePrilojenie(form, formedId);
  // console.log(form, formedId);
};

export const GenerateSchetAndAct = async (form, formedId, date, schetId) => {
  GenerateAct(form, formedId, schetId);
  if (form.paymentMethod === "Безналичный расчет") {
    GenerateSchet(form, formedId, schetId, date);
  }
};
